import Vue from 'vue'
import httpClient from '@uc/httpClient'
import moment from 'moment'
import { getBaseUrls } from './baseURLhelper'
import languageFallbackGr from '../helpers/languages/languageFallback-el'

export const setLocale = async function (lang) {
  let httpClientNoAuth = httpClient.create()

  Vue.locale(lang, () => {
    return httpClientNoAuth.get(getBaseUrls('baseStatic') + `/i18n/${lang}.js`)
      .then((response) => {
        if (Object.keys(response.data).length === 0) {
          return Promise.reject((new Error('locale empty')))
        } else {
          return Promise.resolve(response.data)
        }
      })
      .catch((error) => {
        // TODO handle error
        if (lang === 'el') {
          return Promise.resolve(languageFallbackGr.value)
        }
        return Promise.reject(error)
      })
  }, () => {
    Vue.config.lang = lang
    let locale = ''
    switch (lang) {
      case 'srb':
        locale = 'sr'
        break
      case 'bih':
        locale = 'bs'
        break
      case 'en':
        locale = 'en'
        break
      case 'hr':
        locale = 'hr'
        break
      case 'mk':
        locale = 'mk'
        break
      case 'sl':
        locale = 'sl'
        break
      case 'cg':
        locale = 'me'
        break
      case 'el':
        locale = 'el'
        break
      default:
        locale = 'en'
    }
    moment.locale(locale)
    moment.updateLocale(locale, {
      calendar: {
        // TODO check relative days days
        sameDay: `[${Vue.t('guide_calendar_date_today')}]`,
        nextDay: `[${Vue.t('event_relativedate_tomorrow')}]`,
        nextWeek: 'dddd',
        lastDay: `[${Vue.t('event_relativedate_yesterday')}]`,
        lastWeek: `[${Vue.t('Last')}] dddd`,
        sameElse: 'DD/MM/YYYY'
      }
    })
    httpClientNoAuth = null
  })
}



// WEBPACK FOOTER //
// ./src/helpers/locale.js